import {
	reactive,
	ref,
	watch,
} from '@vue/composition-api';

const transformChannels = (channels = []) => {
	return channels.map((channel) => {
		return {
			...channel,
			qty: 0,
		};
	});
};

const allocateChannel = (props, context, options = {}) => {
	const { defaultState = {} } = options;

	const formOrigin = reactive({
		minQty: 0,
		channels: defaultState.channels !== undefined
			? transformChannels(defaultState.channels)
			: [],
	});

	const event = reactive({
		isEditAtIndex: false,
	});

	const form = reactive({
		minQty: 0,
		channels: defaultState.channels !== undefined
			? transformChannels(defaultState.channels)
			: [],
	});

	const list = ref([]);

	const modalConfirm = reactive({
		isShow: false,
		deleteIndex: -1,
	});

	const openModal = (e, defaultForm, index) => {
		if (defaultForm) {
			form.minQty = defaultForm.minQty;
			form.channels = defaultForm.channels;
			event.isEditAtIndex = index;
		} else {
			form.minQty = 0;
			form.channels = formOrigin.channels;
			event.isEditAtIndex = -1;
		}

		context.refs['modal-condition'].open();
	};

	const openModalConfirm = (index) => {
		modalConfirm.deleteIndex = index;
		modalConfirm.isShow = true;
	};

	const handleSubmit = ({ minQty, channels }) => {
		form.minQty = formOrigin.minQty;
		form.channels = formOrigin.channels;

		const isEdit = event.isEditAtIndex !== -1;

		if (isEdit) {
			list.value[event.isEditAtIndex].minQty = minQty;
			list.value[event.isEditAtIndex].channels = channels;
		} else {
			list.value.push({ minQty, channels });
		}

		context.emit('onDone', list.value);
	};

	const handleConfirmDelete = () => {
		list.value.splice(modalConfirm.deleteIndex, 1);
		modalConfirm.isShow = false;
	};

	const handleCancelDelete = () => {
		modalConfirm.isShow = false;
	};

	const onClickEdit = (e, index) => {
		const item = list.value[index] || {};
		form.minQty = item.minQty;
		form.channels = item.channels;

		openModal(e, form, index);
	};

	const watchPropChannels = (newChannels) => {
		formOrigin.channels = transformChannels(newChannels);
		form.channels = transformChannels(newChannels);
	};

	const watchPropConditions = (newConditions) => {
		if (!list.value.length) {
			list.value = newConditions;
		}
	};

	watch(() => props.channels, watchPropChannels);

	watch(() => props.conditions, watchPropConditions);

	return {
		form,
		list,
		modalConfirm,
		openModal,
		openModalConfirm,
		handleSubmit,
		onClickEdit,
		handleConfirmDelete,
		handleCancelDelete,
	};
};

export default allocateChannel;